/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Dispatch, FC, SetStateAction, useEffect } from 'react'
import { Turnstile } from '@marsidev/react-turnstile'

interface Props {
  setLoadingTurnstile: Dispatch<SetStateAction<boolean>>
  turnstuleRef: any
}

const TurnstileCaptcha: FC<Props> = ({
  setLoadingTurnstile,
  turnstuleRef,
}: Props) => {
  const RECAPTCHA_ENABLED = Boolean(
    parseInt(process?.env?.REACT_APP_RECAPTCHA_ENABLED || '1', 10)
  )
  useEffect(() => {
    if (!RECAPTCHA_ENABLED) setLoadingTurnstile(false)
  }, [RECAPTCHA_ENABLED])

  const handleSuccess = () => {
    setLoadingTurnstile(false) // Mark Turnstile as loaded once token is available
  }

  return RECAPTCHA_ENABLED ? (
    <Turnstile
      ref={turnstuleRef}
      siteKey={process?.env?.REACT_APP_RECAPTCHA_KEY}
      onSuccess={handleSuccess}
      onError={() => console.error('Turnstile verification failed.')}
      onLoad={() => setLoadingTurnstile(true)} // Optionally track when Turnstile starts loading
    />
  ) : (
    <></>
  )
}

export default TurnstileCaptcha
